import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const GiftCardIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect x="0" y="0" width="24" height="24" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M23,11 L23,7.50010618 C23,6.66825884 22.3306292,6 21.5003154,6 L13.2394751,6 C12.6911217,6.61411362 11.8926277,7 11,7 L9,7 L9,11 L23,11 Z M23,12 L9,12 L9,22 L21.4991358,22 C22.3245032,22 23,21.3261108 23,20.4998938 L23,12 Z M1,11 L8,11 L8,7 L6,7 C5.10737227,7 4.30887828,6.61411362 3.76052494,6 L2.49537277,6 C1.67468043,6 1,6.67441828 1,7.50010618 L1,11 Z M1,12 L1,20.4998938 C1,21.331675 1.669832,22 2.50086422,22 L8,22 L8,12 L1,12 Z M12.6281053,5.16578641 C12.8624939,4.83801738 13,4.43573657 13,4 C13,2.88942753 12.1082006,2 11,2 C9.88942753,2 9,2.89179941 9,4 L9,6 L11,6 C11.6415581,6 12.2093164,5.70239149 12.5744418,5.23737933 C12.5901963,5.2119044 12.6081745,5.18794981 12.6281053,5.16578641 Z M13.8304147,5 L21.5003154,5 C22.8825421,5 24,6.11560156 24,7.50010618 L24,20.4998938 C24,21.8789296 22.8762553,23 21.4991358,23 L2.50086422,23 C1.11805084,23 0,21.8844646 0,20.4998938 L0,7.50010618 C0,6.12204651 1.12248266,5 2.49537277,5 L3.16958528,5 C3.059706,4.68737429 3,4.35082973 3,4 C3,2.33654573 4.34010996,1 6,1 C7.04652965,1 7.96366724,1.5304223 8.5,2.3371915 C9.03633276,1.5304223 9.95347035,1 11,1 C12.65989,1 14,2.33654573 14,4 C14,4.35082973 13.940294,4.68737429 13.8304147,5 Z M4.3718947,5.16578641 C4.39182554,5.18794981 4.40980366,5.2119044 4.42555821,5.23737933 C4.79068362,5.70239149 5.35844191,6 6,6 L8,6 L8,4 C8,2.89179941 7.11057247,2 6,2 C4.89179941,2 4,2.88942753 4,4 C4,4.43573657 4.13750606,4.83801738 4.3718947,5.16578641 Z M20.5,17 C20.7761424,17 21,17.2238576 21,17.5 C21,17.7761424 20.7761424,18 20.5,18 L13.5,18 C13.2238576,18 13,17.7761424 13,17.5 C13,17.2238576 13.2238576,17 13.5,17 L20.5,17 Z M16.5,19 C16.7761424,19 17,19.2238576 17,19.5 C17,19.7761424 16.7761424,20 16.5,20 L13.5,20 C13.2238576,20 13,19.7761424 13,19.5 C13,19.2238576 13.2238576,19 13.5,19 L16.5,19 Z"
        />
      </g>
    </g>
  </svg>
);

GiftCardIcon.displayName = "GiftCardIcon";

GiftCardIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

GiftCardIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default GiftCardIcon;
